import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sw-cabn8-materials-dialog',
  templateUrl: './cabn8-materials-dialog.component.html',
  styleUrls: ['./cabn8-materials-dialog.component.scss'],
})
export class Cabn8MaterialsDialogComponent {
  constructor(public dialogRef: MatDialogRef<Cabn8MaterialsDialogComponent>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
